import {
  Component,
  Input,
  AfterViewInit,
  OnChanges, HostBinding
} from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { ProductPanelService } from '../../../product-panel/product-panel.service';
import * as _ from 'lodash';

import { BaseSegmentMixin } from './_base-segment-mixin';
import { DigitalAssetDetailsService } from '../../digital-asset-details.service';
import * as utils from 'utils/utils';
import { PermissionsService } from 'shared/permissions/permissions.service';


@Component({
  template: '',
})
export class BaseSegmentComponent extends BaseSegmentMixin implements AfterViewInit {

  model: any;
  headers: any[] = [];

  @Input() assetDetail: any;

  @Input() declare data: any;

  @Input() async: AsyncSubject<any>;

  // toggle controls edit/view mode
  @HostBinding('class.is-edit-mode')
  editMode: boolean = false;

  constructor(
    protected digitalAssetDetailsService: DigitalAssetDetailsService,
    protected permissionsService: PermissionsService,
    // protected productPanelService: ProductPanelService,
  ) {
    super();
    this.model = this.digitalAssetDetailsService.model;
  }

  ngAfterViewInit() {
    this.async.next(this.data);
    this.async.complete();
  }

  onEditButtonClick(segmentName: string) {
    if (!segmentName) { return console.warn('Segment name is undefined!'); }
    const data = {
      id: this.assetDetail._id,
      partNumber: this.assetDetail.partNumber,
      title: _.get(this.assetDetail, 'descriptions.DES.EN', ''),
      updated_at: this.assetDetail.updated_at
    };
    // this.productPanelService.toggleProductPanelModal(true, segmentName, data);
  }

  public getItemProperty(item: any, path: string): any {
    const property = utils.getItemProperty(item, path, this.assetDetail);
    if (!property) {
      switch (item.type) {
        case 'list':
          return [];
        default:
          return '';
      }
    }
    return property;
  }

  get displayData(): Array<any> {
    return _.filter(this.data, ['show_more', true]);
  }

  get displayEdit(): Boolean {
    return (
      this.assetDetail &&
      this.assetDetail._id &&
      _.indexOf([0, 1, 2], this.assetDetail.status) > -1 &&
      this.hasPermission(['admin', 'dam-edit'])
    );
  }

  get displayShowMoreData(): Array<any> {
    return _.filter(this.data, ['show_more', false]);
  }

  public isHeader(name: string): boolean {
    return _.indexOf(this.headers, name) >= 0;
  }

  public hasError(path: string, language: string= null) {
    if (language) { path += '.' + language; }
    if (!_.has(this, 'assetDetail.validation.combinedErrors')) { return false; }

    return _.some(this.assetDetail.validation.combinedErrors, (item: string) => {
      return item.indexOf(path) !== -1;
    });
  }

  getFieldByName(name: string) {
    return utils.getFieldByName(name, this.data);
  }

  hasPermission(allow: Array<string>|string, requireAll: boolean= false): boolean {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

}
